import datetimepickerTimepickerDirectiveTemplate from './datetimepicker-timepicker.directive.html';
import datetimepickerDirectiveTemplate from './datetimepicker.directive.html';

/* @ngInject */
export const templates = ($templateCache) => {
	$templateCache.put('datetimepicker/datetimepicker-timepicker.directive.html', datetimepickerTimepickerDirectiveTemplate);
	$templateCache.put('datetimepicker/datetimepicker.directive.html', datetimepickerDirectiveTemplate);
};
